import { Map } from 'immutable';

import * as t from './actionTypes';

const initialState = Map({
  settings: [],
  loading: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case t.SET_SETTINGS:
      return state.set('settings', action.settings);

    case t.SET_LOADING:
      return state.set('loading', action.value);

    case t.SET_COMMON_AI_ADMIN_FEEDBACK_TEMPLATES:
      return state.set('commonAiAdminFeedbackTemplates', action.value);

    default:
      return state;
  }
}
